export default function() {
  this.namespace = '/api/v3'

  this.passthrough('https://api.labelbox.com/**')

  this.get('events/:id', function(schema, request) {
    const id = request.params.id
    return schema.events.find(id)
  })

  this.get('events/:id/images', function(schema, request) {
    const id = request.params.id
    return schema.images.where({ eventId: id })
  })

  this.get('installations/:id', function(schema, request) {
    const id = request.params.id
    return schema.installations.find(id)
  })

  // This endpoint actually returns all foodItems from a menu
  // Used to get the menuName from the first object. FML
  this.get('menu/:id', function(schema) {
    return schema.menus.all()
  })
}
